module.exports = __webpack_public_path__ + "img/active.5f0430cd.svg";